import PropTypes from 'prop-types';
import React from 'react';
import Avatar from 'react-avatar';
import {
 ButtonToolbar,
 Button,
 Image,
 Badge,
 Modal,
} from 'react-bootstrap';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import Griddle, { plugins, RowDefinition, ColumnDefinition } from 'griddle-react';
import { Link,browserHistory } from 'react-router';
import { tourType } from './CatchPropTypes';
import unpin from '../../../../public/unpin.png';
import pin from '../../../../public/pin.png';

const styleConfig = {
  icons: {
    TableHeadingCell: {
      sortDescendingIcon: '▼',
      sortAscendingIcon: '▲',
    },
  },
  classNames: {
    Row: 'row-class',
    Table: 'table-striped table',
    Filter: 'pull-right form-control',
  },
  styles: {
    Filter: { fontSize: 18 },
  },
};

class TourTableView extends React.Component {
  constructor() {
    super();
    this.state = {
      show: false,
      showView:false,
    };

    this.getManageBid = this.getManageBid.bind(this);
    this.openTour = this.openTour.bind(this);
    this.changeTourPin = this.changeTourPin.bind(this);
  }
  getManageBid(e){
    const value = e.currentTarget.getAttribute('data-item');
    let state = null;
    let group = 0;
    let cities = 0;
    this.props.tours.forEach((tour) => {
      if(tour.id==value){
        state=tour.state;
        group=tour.groups;
        cities=tour.cities;
      }
    })
    const archived = (state === 'AR');
    const showHotels = (
      (group.length !== 0) && (cities !== 0)
        && !archived);
    const disable = showHotels?false:true;
    if(disable==true){
      alert("Manage bid is not defined for this tour.")
    } else{
      const url = `/tours/${value}/hotels/4`;
      browserHistory.push(url);
    }
  }
  openTour(e){
    const id = e.currentTarget.getAttribute('data-item');
    const url = `/tours/${id}/overview`;
    browserHistory.push(url);
  }
  changeTourPin(tour){
    this.props.changePinStatus(tour);
  }

  render() {
    const style = {'cursor':'pointer'};
    const toursList =[];
    this.props.tours.forEach((tour) => {
      if (!this.props.filter[tour.state]) {
        toursList.push({
          'id':tour.id,
          'name':tour.name,
          'tagLine':tour.tag_line,
          'state':tour.state,
          'date':`${tour.start} To ${tour.end}`,
          'tour':tour.id,
          'pin': tour.id,
        })
      }
    }); 

    const openpinColumn = ({value})=>{
      const val = this.props.tours.find(v=>v.id==value)
      const pinVal = val.pin_tour?pin:unpin;
      return(
        <div>
          <img className="pin-unpin-image" data-item={val} style={style} src={pinVal} alt="Pin" onClick={() => this.changeTourPin(val)}/>
        </div>
        )
    }

    const opentourColumn = ({value})=>{
      return (
        <div>
          <Button bsStyle="success" data-item={value} onClick={this.openTour}>See Details</Button>
        </div>
      );
    }
    const manageColumn = ({value})=>{
      return (
        <div>
          <Button bsStyle="success" data-item={value} onClick={this.getManageBid}>Go To Manage Bid</Button>
        </div>
      );
    }

    return (
      <div>
        <Griddle
          data={toursList}
          plugins={[plugins.LocalPlugin]}
          styleConfig={styleConfig}
          showFilter={true}
          components={{
            SettingsToggle: () => <span />,
            //Pagination: () => <span />,
          }}

        >
          <RowDefinition>
            <ColumnDefinition id="pin" order={1} title=" " customComponent={openpinColumn}/>
            <ColumnDefinition id="name" order={2} title="Name"  />
            <ColumnDefinition id="tagLine" order={3} title="Tag Line" />
            <ColumnDefinition id="state" order={4} title="Status" />
            <ColumnDefinition id="date" order={5} title="Date" />
            <ColumnDefinition id="id" order={99} title=" " customComponent={opentourColumn} />
            <ColumnDefinition id="tour" order={100} title=" " customComponent={manageColumn} />
          </RowDefinition>
        </Griddle>
      </div>
    );
  }
}

export default TourTableView;



// WEBPACK FOOTER //
// src/routes/tours/components/TourTableView.js